import _ from 'lodash'
import { WEEK_LABELS } from '../constants'
import moment from 'moment-mini'
import DateCell from '../DateCell'
import WeekCell from '../WeekCell'

export default {
  name: 'KDatePickerDateView',
  inject: ['picker', 'context'],
  props: {
    referenceValue: moment,
    // weekStartDay: {
    //   type: Number,
    //   default: 1,
    // },
  },
  data() {
    return {}
  },
  computed: {
    weekStartDay() {
      return this.context.weekStartDay || 1
    },
    weekLabels() {
      return [...WEEK_LABELS, ...WEEK_LABELS].slice(this.weekStartDay, this.weekStartDay + 7)
    },
    startOfMonth() {
      return this.referenceValue.clone().startOf('month')
    },
    startDayOfWeek() { // 所属月的第一天是星期几
      return this.startOfMonth.day()
    },
    viewStartDate() {
      let offset = this.startDayOfWeek - this.weekStartDay
      offset = offset > 0 ? offset : 7 + offset
      offset = offset === 0 ? 7 : offset

      return this.startOfMonth.clone().subtract(offset, 'd')
    },
    viewStartWeekOfYear() {
      return this.viewStartDate.week()
    },
    weeks() {
      const weeks = [{}, {}, {}, {}, {}, {}]
      let offset = 0
      for (let i = 0; i < weeks.length; i++) {
        const week = {
          week: this.viewStartWeekOfYear + i,
          dates: [],
        }
        for (let j = 0; j < 7; j++) {
          week.dates.push(this.viewStartDate.clone().add(offset, 'd'))
          offset++
        }

        weeks[i] = week
      }
      return weeks
    },
  },
  watch: {},
  created() {
  },
  methods: {},
  render() {
    const css = {
      'km-date-picker__view': true,
    }

    const data = {
      class: css,
    }

    return (
      <div {...data}>
        <div class="km-date-picker__dates">
          <div class="km-date-picker__week-labels">
            {
              _.map(this.weekLabels, label => (
                <div>
                  {label}
                </div>
              ))
            }
          </div>

          {
            _.map(this.weeks, (week, index) => (
              <WeekCell
                weekOfYear={this.viewStartWeekOfYear + index}
              >
                {
                  _.map(week.dates, date => (
                    <DateCell
                      referenceValue={this.referenceValue}
                      value={date}
                    >
                      {this.$scopedSlots.default}
                    </DateCell>
                  ))
                }
              </WeekCell>
            ))
          }
        </div>
      </div>
    )
  },
}
